import { Box, Drawer as ChakraDrawer, HStack, Icon, IconButton, Text } from '@chakra-ui/react';
import { LuX } from 'react-icons/lu';

import { handleDropdownAwareClose } from '@/utils/dropdownInteraction';

type DrawerPlacement = Parameters<typeof ChakraDrawer.Root>[0]['placement'];
type DrawerSize = Parameters<typeof ChakraDrawer.Root>[0]['size'];

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  placement?: DrawerPlacement;
  size?: DrawerSize;
  hideCloseButton?: boolean;
  customHeader?: React.ReactNode;
  bodyPt?: number | string;
}

const Drawer = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  placement = 'end',
  size = 'md',
  hideCloseButton = false,
  customHeader,
  bodyPt,
}: DrawerProps) => {
  return (
    <ChakraDrawer.Root
      open={isOpen}
      onOpenChange={(e) => handleDropdownAwareClose(e.open, onClose)}
      placement={placement}
      size={size}
    >
      <ChakraDrawer.Backdrop />
      <ChakraDrawer.Positioner>
        <ChakraDrawer.Content>
          {(customHeader || title || !hideCloseButton) && (
            <ChakraDrawer.Header px={6} pt={6} pb={0}>
              <HStack justify="space-between" align="center" width="100%">
                {customHeader ? (
                  <>
                    {customHeader}
                    {!hideCloseButton && (
                      <IconButton
                        variant="ghost"
                        size="sm"
                        onClick={onClose}
                        aria-label="Close drawer"
                        _hover={{ backgroundColor: 'gray.100' }}
                      >
                        <Icon as={LuX} boxSize={5} color="gray.600" />
                      </IconButton>
                    )}
                  </>
                ) : (
                  <>
                    {title ? (
                      <Text fontSize={24} fontWeight={500} color="fg">
                        {title}
                      </Text>
                    ) : (
                      <Box />
                    )}
                    {!hideCloseButton && (
                      <IconButton
                        variant="ghost"
                        size="sm"
                        onClick={onClose}
                        aria-label="Close drawer"
                        _hover={{ backgroundColor: 'gray.100' }}
                      >
                        <Icon as={LuX} boxSize={5} color="gray.600" />
                      </IconButton>
                    )}
                  </>
                )}
              </HStack>
            </ChakraDrawer.Header>
          )}
          <ChakraDrawer.Body
            px={6} py={6}
            pt={bodyPt}
          >
            {children}
          </ChakraDrawer.Body>
          {footer && (
            <ChakraDrawer.Footer px={6} pb={6} pt={0}>
              {footer}
            </ChakraDrawer.Footer>
          )}
        </ChakraDrawer.Content>
      </ChakraDrawer.Positioner>
    </ChakraDrawer.Root>
  );
};

export default Drawer;